module.exports = __webpack_public_path__ + "static/media/2-2.cba359e9.webp";